import EXERCISES_UI_ACTION from '../../constants/action'
import EXERCISES_UI_PATH from '../../constants/path'
import setReduxAction from '../../../redux/actions/set'
import { getActionStrReduxUtil } from '../../../redux/utils/get-action-str'

function updateQueryExercisesUiAction (value) {
  return setReduxAction({
    type: getActionStrReduxUtil(EXERCISES_UI_ACTION.UPDATE_QUERY, value),
    payload: {
      path: EXERCISES_UI_PATH.QUERY,
      value
    }
  })
}

export default updateQueryExercisesUiAction
